import { render } from "./AssignDistributorModal.vue?vue&type=template&id=08bc5f74&ts=true"
import script from "./AssignDistributorModal.vue?vue&type=script&lang=ts"
export * from "./AssignDistributorModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__